<template>
  <nav>
    <v-app-bar dense flat app :elevation="24" :elevate-on-scroll="true">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="teal--text">Nilo Roberto da Cruz Paim</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon to="/">
        <v-icon>mdi-home-circle</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app class="info" v-model="drawer">
      <v-list dense>
        <v-subheader>Seções</v-subheader>
        <v-list-item-group v-model="item" color="primary">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            router
            :to="item.route"
            @click.stop="drawer = !drawer"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      item: 1,
      items: [
        { text: "Descrição geral", icon: "mdi-home", route: "/" },
        {
          text: "Possibilidades",
          icon: "mdi-menu",
          route: "/options"
        },
        {
          text: "Instalação do Ambiente",
          icon: "mdi-numeric-1",
          route: "/install"
        },
        {
          text: "Instalação do NodeJs",
          icon: "mdi-numeric-2",
          route: "/installnode"
        },
        {
          text: "Instalação do C/C++",
          icon: "mdi-numeric-3",
          route: "/installc"
        },
        {
          text: "Instalação do Go",
          icon: "mdi-numeric-4",
          route: "/installgo"
        },
        {
          text: "Instalação do VS Code",
          icon: "mdi-numeric-5",
          route: "/installvscode"
        },
        {
          text: "Primeiro teste",
          icon: "mdi-numeric-6",
          route: "/firsttest"
        },
        { text: "Quem sou eu", icon: "mdi-account-circle", route: "/about" }
      ]
    };
  }
};
</script>